import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from '@/components/shared/PageLayout';
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { ContextualToolbar, ToolbarButtonGroup } from "@/components/ui/contextual-toolbar";
import { AdminModeButton } from "@/components/admin/AdminModeButton";
import { HarryAvatar } from "@/components/icons";

export default function ChatPage() {
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);

  return (
    <PageLayout
      title="Ask Harry"
      subtitle="Ask questions and get insights from the course material"
    >
      <div className="max-w-4xl mx-auto">

        <Card className="shadow-md rounded-lg max-w-xl">
          <div className="p-6 flex items-center gap-4">
            <div className="h-16 w-16 rounded-full border-2 border-accent overflow-hidden bg-surface flex items-center justify-center" aria-label="Harry avatar">
              <HarryAvatar />
            </div>
            <div>
              <div className="text-xl font-semibold">Chat with Conor's AI Assistant</div>
              <div className="text-sm text-muted">Powered by NotebookLM</div>
            </div>
          </div>
          <div className="px-6 pb-6 space-y-4">
            <p className="text-muted leading-relaxed">Ready to dive deeper? Chat with my AI assistant, trained on all the course materials, to get instant answers to your questions.</p>
            <ul className="text-sm space-y-1">
              <li>✓ Trained on complete biomechanics course</li>
              <li>✓ Instant answers to technical questions</li>
              <li>✓ Drill recommendations and progressions</li>
              <li>✓ Assessment interpretation help</li>
            </ul>
            <a href="https://notebooklm.google.com/notebook/51de775f-3daa-4b06-8a1e-bb775b47b1fd" target="_blank" rel="noreferrer" className="block">
              <Button className="w-full h-12">
                Open Chat <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </a>
            <p className="text-xs text-muted mt-2">Opens in a new tab. Your conversations are private.</p>
          </div>
        </Card>

        <Card className="shadow-sm rounded-lg mt-6">
          <div className="p-4 border-b">
            <h4 className="text-lg font-semibold">Need More Help?</h4>
          </div>
          <div className="p-4 space-y-2">
            <Link to="/progression-model" className="block">
              <Button variant="ghost" className="justify-start w-full">Progression Model guide</Button>
            </Link>
            <Link to="/coaching" className="block">
              <Button variant="ghost" className="justify-start w-full">Coaching principles</Button>
            </Link>
          </div>
        </Card>
      </div>
    </PageLayout>
  );
}
